export function formatNumber(num) {
    var currency_symbols = {
      'USD': '$', // US Dollar
      'EUR': '€', // Euro
      'CRC': '₡', // Costa Rican Colón
      'GBP': '£', // British Pound Sterling
      'ILS': '₪', // Israeli New Sheqel
      'INR': '₹', // Indian Rupee
      'JPY': '¥', // Japanese Yen
      'KRW': '₩', // South Korean Won
      'NGN': '₦', // Nigerian Naira
      'PHP': '₱', // Philippine Peso
      'PLN': 'zł', // Polish Zloty
      'PYG': '₲', // Paraguayan Guarani
      'THB': '฿', // Thai Baht
      'UAH': '₴', // Ukrainian Hryvnia
      'VND': '₫', // Vietnamese Dong
  };
  
    var currency_name = 'INR';
    var n1, n2;
    // let's get the position of the radix-point
    var radixPos = String(num).indexOf('.');
    // now we can use slice, on a String, to get '.15'
    var value = String(num).slice(radixPos);
    var floor=value.length
    if(floor > 2){
        num = parseFloat(num).toFixed(2) + '' || '';
        // works for integer and floating as well
        n1 = num.split('.')
        n2 = n1[1] || null;
        n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
        num = n2 ? n1 + '.' + n2 : n1;
    }
    return currency_symbols[currency_name] + " "+ num;
  }